/* eslint-disable @typescript-eslint/no-explicit-any */
export const isArray = (a: any) => Array.isArray(a)
export const isObject = (o: any) =>
  o === Object(o) && !isArray(o) && typeof o !== 'function'
